import googleTagManagerJs from './raw/google-tag-manager?raw';

type Props = {
  trackingId: string;
};

export function HorizonGoogleTagManagerScript({ trackingId }: Props) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: googleTagManagerJs.replace('||__TRACKING_ID__||', trackingId),
      }}
    />
  );
}
